import React, { FC, useMemo } from 'react';
import { getContactName } from '../../utils/DataFormatterUtils';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { NEW_NOTE_TYPES } from '../../utils/WebSocketUtils';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';

const sampleData = {
	messageType: 'new_note',
	workOrderId: 2279176,
	message:
		'Page layouts look better with something in each section. Web page designers, content writers, and layout artists use lorem ipsum, also known as placeholder copy, to distinguish which areas on a page will hold advertisements, editorials, and filler before the final written content and website designs receive client approval.',
	sentBy: {
		email: 'mprasanna+admin@useopenwrench.com',
		nameGiven: 'Prasanna',
		nameFamily: 'Admin',
		contactType: 'buyer',
	},
};

const NewMessageNotification: FC<any> = ({ data }): React.ReactElement => {
	const messageAvailable = !!data.message;

	const suffix = useMemo(() => {
		switch (data.newNoteType) {
			case NEW_NOTE_TYPES.IMAGE:
				return 'an image';
			case NEW_NOTE_TYPES.VIDEO:
				return 'a video';
			case NEW_NOTE_TYPES.AUDIO:
				return 'an audio note';
			default:
				return 'a note';
		}
	}, [data.newNoteType]);

	const secondLine = useMemo(
		() =>
			messageAvailable ? (
				<Ellipsis className={`bodyregular`} lines={3}>
					{data.message}
				</Ellipsis>
			) : (
				`Sent you ${suffix}`
			),
		[data.message, suffix, messageAvailable]
	);

	return (
		<div className="flex-start flex flex-col gap-2">
			<div className="flex flex-row items-center gap-2">
				<ContactAvatar hidePopover contact={data.sentBy} />
				<div className="h5medium">{getContactName(data.sentBy)}</div>
			</div>
			{secondLine ? (
				<div
					className={`bodyregular`}
					style={{
						...(!messageAvailable && { fontStyle: 'italic' }),
					}}
				>
					{secondLine}
				</div>
			) : null}
		</div>
	);
};

export default NewMessageNotification;
